import { AuthenticationMode } from '@softline/auth';

export const environment = {
  production: true,
  recaptchaSiteKey: '6LcgmFkUAAAAACcqE7VX5ft4linzJlEafUAGl3d8',
  // Shared by 60+ build configs — all JWT. apps.softline.at is the only BFF
  // system and uses src/environments/environment.bff.ts instead.
  authentication: 'jwt' as AuthenticationMode,
  connection: {
    name: 'SoftApps',
    host: location.protocol + '//' + location.hostname,
    port: Number(location.port),
    basePath: '/api',
  },
};
